import { Component } from 'react'
import AppContainer from './AppContainer.js'
import Login from './pages/Login.js'
import Settings from './pages/Settings.js'
import Welcome from './pages/Welcome.js'
import Container from './shared/Container.js'
import EditData from './shared/EditData.js'
import LoadingCircle from './shared/LoadingCircle.js'
import Translate from './shared/Translate.js'
import { getCookieLanguage, errorLogEnabled, logEnabled, setCookieLanguage } from './shared/Utils.js'
import { hideFloatingWindow, showFloatingWindow, subsribeToVisibilityEvents } from './shared/customUiSdk.js'
import './styles/common.css'

class InitializedApp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      credentials: props.credentials,
      settingsOpened: false,
      openedSection: undefined,
      sdk: props.sdk,
      isVisible: false,
    }

    this.container = new Container(this, 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo',
      (err) => errorLogEnabled && console.error(err))

    this.stateData = new EditData(this, '')
    this.settingsData = new EditData(this, 'settings')
    this.setProvidedNumber = this.setProvidedNumber.bind(this)
    this.openMainPage = this.openMainPage.bind(this)
    this.disableFullScreenNotificationExpiration = this.disableFullScreenNotificationExpiration.bind(this)
  }

  componentDidMount() {
    this.container.tell({
      _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$Get',
      time: new Date().getTime(),
      credentials: this.state.credentials,
    })

    subsribeToVisibilityEvents(this.state.sdk, (data) => {
      logEnabled && console.log('Visibility event:', data)
      this.setState({ isVisible: data.is_visible })
      if (!data.context.callToNumber) {
        // normal page open, set the section to collapsed if already not
        if (!this.state.providedNumber) {
          this.setState({ openedSection: undefined })
        }
        // go to main page if is_visible is false
        if (!data.is_visible) {
          this.openMainPage()
        }
      }
      else {
        this.openMainPage()
        this.setProvidedNumber(data.context.callToNumber)
      }
    })

    // call this to update cache of line titles
    this.container.ask({
      _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$GetUserLinesAndDevices'
    }).catch((error) =>
      errorLogEnabled && console.error('Failed to fetch available lines and devices:', error)
    )
  }

  componentWillUnmount() {
    this.container.close()
  }

  componentDidUpdate(_, prevState) {
    const { sdk, fullScreenNotification, mainScreenNotifications, settings } = this.state;
    if (sdk && settings && !this.state.isVisible && ((fullScreenNotification && !prevState.fullScreenNotification) || 
        (!settings.silentMode && (mainScreenNotifications || []).length > (prevState.mainScreenNotifications || []).length))) {
      logEnabled && console.log('Showing floating window')
      this.disableFullScreenNotificationExpiration()
      showFloatingWindow(sdk)
      this.setState({ closeAutomatically: true })
    }
    if (sdk && settings && this.state.closeAutomatically && this.state.isVisible  && 
        ((!fullScreenNotification && prevState.fullScreenNotification) || (mainScreenNotifications || []).length === 0)) {
      logEnabled && console.log('Hiding floating window')
      this.setState({ closeAutomatically: false })
      hideFloatingWindow(sdk)
    }
    if (settings && settings.language && settings.language !== prevState.settings?.language) {
      if (Translate.language !== settings.language) Translate.setLanguage(settings.language)
      if (getCookieLanguage() !== settings.language) setCookieLanguage(settings.language)
    }
  }

  setProvidedNumber(number) {
    logEnabled && console.log('Setting provided "call to" number:', number)
    this.setState({ providedNumber: undefined }, () => this.setState({ providedNumber: number }))
  }

  openMainPage() {
    if (this.state.fullScreenNotification) {
      this.container.tell({
        _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$CloseFullScreenNotification',
      })
    }
    logEnabled && console.log('Opening main page')
    this.setState({
      settingsOpened: false,
      fullScreenNotification: undefined,
      openedSection: undefined,
      providedNumber: undefined,
    })
  }

  disableFullScreenNotificationExpiration() {
    if (this.state.closeAutomatically) {
      this.setState({ closeAutomatically: false })
      this.container.tell({
        _class: 'com.optimsys.costra.optimcall.pipedrive.user.CurrentUserInfo$DisableFullScreenNotificationExpiration',
      })
    }
  }

  render() {
    if (this.state.isAuthorized === undefined) {
      return <LoadingCircle />
    }

    if (!this.state.isDomainRegistered || !this.state.adminInfo?.isAuthorized) {
      return <Welcome 
        isDomainRegistered={this.state.isDomainRegistered}
        adminInfo={this.state.adminInfo}
        container={this.container}
      />
    }

    if (!this.state.isAuthorized) {
      return <Login
        container={this.container}
        ocTenant={this.state.ocTenant}
        onLogin={() => this.setState({ settingsOpened: false })} 
      />
    }

    if (this.state.settingsOpened) {
      return <Settings
        {...this.state}
        container={this.container}
        settingsData={this.settingsData}
        onClose={() => this.setState({ settingsOpened: false })}
      />
    }

    if (this.state.fullScreenNotification && this.state.fullScreenNotification.event.callType) {
      return <AppContainer
        showCallDetail
        component={this}
      />
    }

    if (this.state.fullScreenNotification && this.state.fullScreenNotification.event.smsId) {
      return <AppContainer
        showSmsDetail
        component={this}
      />
    }

    return <AppContainer
      showMain
      component={this}
    />
  }
}

export default InitializedApp